import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getDepartments = async ({ companyCode, isTrue = true }) => {
  if (!companyCode) return [];
  const data = await http_payroll.get(
    `${Api_EndPoints.GetDepartments}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetAllDepartmentQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetDepartments],
    queryFn: () => getDepartments(input),
    refetchOnWindowFocus: false,
  });
};
